export default function Sidebar({ page, setPage, collapsed, setCollapsed, mobileOpen, setMobileOpen }) {
  const NAV = [
    {
      section: 'Main',
      items: [
        { key: 'dashboard', icon: '⊞', label: 'Dashboard' },
      ]
    },
    {
      section: 'Reports',
      items: [
        { key: 'sales',   icon: '📈', label: 'Sales Report'   },
        { key: 'payment', icon: '💳', label: 'Payment Report' },
      ]
    },
    {
      section: 'Data',
      items: [
        { key: 'transactions', icon: '🧾', label: 'Transactions' },
        { key: 'customers',    icon: '👥', label: 'Customers'    },
        { key: 'states',       icon: '🗺️', label: 'States'      },
      ]
    },
  ];

  const go = (key) => { setPage(key); setMobileOpen(false); };

  return (
    <>
      {mobileOpen && (
        <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
      )}

      <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>

        {/* Logo */}
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">📊</div>
          {!collapsed && (
            <div className="sidebar-logo-text">
              <h2>Sales Dashboard</h2>
              <span>DARJUV9 Enterprises</span>
            </div>
          )}
        </div>

        {/* Nav */}
        {NAV.map(section => (
          <div key={section.section} className="sidebar-section">
            <div className="sidebar-section-label">{section.section}</div>
            {section.items.map(item => (
              <button
                key={item.key}
                className={`nav-item ${page === item.key ? 'active' : ''}`}
                onClick={() => go(item.key)}
                title={collapsed ? item.label : ''}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </button>
            ))}
          </div>
        ))}

        {/* Collapse toggle */}
        <div className="sidebar-collapse-btn">
          <button
            onClick={() => setCollapsed(c => !c)}
            className="nav-item"
            style={{ justifyContent: collapsed ? 'center' : 'flex-start' }}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <span className="nav-icon" style={{ fontSize: '14px' }}>{collapsed ? '»' : '«'}</span>
            <span className="nav-label">Collapse</span>
          </button>
        </div>
      </aside>
    </>
  );
}
